import React, { Fragment } from 'react';
import Link from 'next/link';
import styles from './styles';

function SignInPrompt() {
  return (
    <Fragment>
      <style jsx>{styles}</style>
      <div className="SignInPrompt">
        <p>
          You&apos;re not authenticated yet. Maybe you want to{' '}
          <Link href="/sign-in" prefetch={false}>
            <a data-gtm-placement="Not Authorized Page" rel="nofollow">
              sign in
            </a>
          </Link>{' '}
          and see what happens?
        </p>
      </div>
    </Fragment>
  );
}

export default SignInPrompt;
